import React, { useState, useEffect, useRef } from "react";
import PLinea from "../img/Boton_1.webp";
import ventanilla from "../img/Boton_2.webp";
import "./FormaPago.css";
import { Redirect, useHistory } from "react-router-dom";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { usePagoVentanilla } from "../hooks/usePagoVentanilla";
import { PAGOS_API_URL } from "../config";
import { plantelDeMatricula } from "../utilities/plantel";
import { evaluarRespuestaVCE } from "../utilities/resultadoPagoLinea";
import { asegurarVersionVigenteAlumno } from "../utilities/versionApp";

const FormaPago = ({ alumno, datospago, tablaConceptos }) => {
  const history = useHistory();
  const { cargandoPdf, generarFolioTPV, guardarIntencionBD, descargarPdf } = usePagoVentanilla(alumno);
  
  const [banorteMessage, setBanorteMesagge] = useState("");
  const [loading, setLoading] = useState(false);
  const [conceptosProcesados, setConceptosProcesados] = useState([]);
  const [intencionGuardada, setIntencionGuardada] = useState(false);
  // Referencias de pago en linea que ya se guardaron (cada intento de pago genera una nueva);
  // evita guardar dos veces el mismo pago sin bloquear un reintento.
  const referenciasEnLineaGuardadas = useRef(new Set());
  
  // Estados recuperados para controlar la visibilidad del botón y guardar el folio
  const [pdf, cambiarPdf] = useState(false);
  const [folioRegistro] = useState("");
  const [fechaVencimiento, setFechaVencimiento] = useState("");

const handleOnClickVentanilla = async () => {
    if (!intencionGuardada && conceptosProcesados.length > 0) {
      // 1. Generamos el folio
      const nuevoFolio = generarFolioTPV();
      
      // 2. INYECTAMOS el folio en cada fila de la tabla
      const tablaConFolio = conceptosProcesados.map(item => ({
        ...item,
        folioTPV: item.folioTPV || nuevoFolio // Respeta si ya trae uno, si no, le asigna el nuevo
      }));
      
      // 3. Actualizamos la tabla para que el componente PDF la lea correctamente
      setConceptosProcesados(tablaConFolio);

      // 4. Guardamos en la base de datos
      const importePDF = tablaConFolio.reduce((sum, item) => sum + Number(item.precio), 0);
      const refBanortePDF = tablaConFolio[0].referencias.Banorte;
      const refBbvaPDF = tablaConFolio[0].referencias.BBVA;

      await guardarIntencionBD(tablaConFolio, importePDF, refBanortePDF, refBbvaPDF, nuevoFolio, "VENTANILLA");
      
      // 5. Bloqueamos futuros clics
      setIntencionGuardada(true);
    }
    
    // 6. Finalmente, ordenamos que aparezca el botón verde
    cambiarPdf(true); 
  };

  const pagoBanorte = async (importe, referencia) => {
    let xObjEnc;
    // La API usa la matricula como "Dato de compra" (customerRef4) del voucher digital de Banorte;
    // solo la matricula (14 caracteres) porque Banorte agrega "VCE" y con mas caracteres el pago
    // falla. datoCompra (nombres de los conceptos) tambien se manda, pero hoy la API lo ignora.
    const datoCompra = conceptosProcesados.map((item) => item.concepto).filter(Boolean).join(", ");
    const body = { referencia, importe, datoCompra, matricula: String(alumno.codigo || "") };
    setLoading(true);

    // Antes de abrir la ventana de Banorte: si la pagina quedo vieja (se publico una version nueva mientras
    // estaba abierta, o el navegador guardo una copia), se avisa y se recarga; una pagina vieja podria guardar
    // como pagado un cobro que Banorte rechazo.
    if (!(await asegurarVersionVigenteAlumno())) {
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${PAGOS_API_URL}/referenciaBanorte`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      });

      let data = null;
      try {
        data = await response.json();
      } catch (e) {
        data = null;
      }
      // Sin datos para la ventana de Banorte no se abre (antes se abria vacia): 503 = el cifrador no esta
      // disponible; 400 = la solicitud no paso la validacion del servicio; 200 con {} = servicio anterior.
      if (!response.ok || !data || !data.data) {
        setBanorteMesagge(response.status === 400
          ? "No se pudo preparar el pago. No se hizo ningún cobro; recarga la página e intenta de nuevo."
          : "El servicio de pagos no está disponible en este momento. No se hizo ningún cobro; intenta de nuevo en un minuto.");
        setLoading(false);
        return;
      }
      xObjEnc = data.data;
      // vi/salt/passphrase: llaves con las que se descifra la respuesta de Banorte en onSuccess
      const clavesVCE = { vi: data.vi, salt: data.salt, passphrase: data.passphrase };

      window.Payment.startPayment({
        Params: xObjEnc,
        onClosed: () => setLoading(false),
        onError: (response) => {
          setBanorteMesagge(response.message || "Error en el pago");
          setLoading(false);
        },
        onSuccess: (response) => {
          setLoading(false);
          // La ventana llama a onSuccess aunque Banorte haya declinado el cobro: solo se
          // guarda el pago si el resultado es "aprobado" (ver utilities/resultadoPagoLinea.js).
          const evaluacion = evaluarRespuestaVCE(response, clavesVCE);
          if (evaluacion.desconocido) {
            // No se sabe si Banorte cobro: NO se guarda nada (el servidor tampoco lo aceptaria sin autorizacion).
            // Si el cobro fue real, se da de alta desde el modulo de Conciliacion.
            console.warn("No se pudo confirmar el resultado del pago con Banorte; no se guarda:", evaluacion.error || response);
            setBanorteMesagge("No pudimos confirmar tu pago. Si tu banco te hizo el cargo, conserva tu comprobante y repórtalo en tu plantel; no vuelvas a pagar hasta confirmarlo.");
            return;
          }
          if (!evaluacion.aprobado) {
            setBanorteMesagge(`El pago no fue aprobado (${evaluacion.motivo}). No se realizó ningún cobro; intenta de nuevo o con otra tarjeta.`);
            return;
          }
          setBanorteMesagge("Pago Exitoso");
          if (!referenciasEnLineaGuardadas.current.has(referencia)) {
            referenciasEnLineaGuardadas.current.add(referencia);
            // La autorizacion de Banorte viaja con el pago: el servidor no guarda un pago en linea sin ella.
            Promise.resolve(guardarIntencionBD(conceptosProcesados, importe, referencia, null, null, "EN_LINEA", evaluacion.autorizacion)).then((guardado) => {
              if (!guardado) {
                setBanorteMesagge(`Banorte aprobó tu pago (autorización ${evaluacion.autorizacion}) pero no se pudo registrar en el sistema. Conserva tu comprobante y avisa en tu plantel con este número de autorización.`);
              }
            });
          }
        },
        onCancel: () => setLoading(false),
      });

    } catch (err) {
      console.error("Error crítico de red o API:", err);
      setBanorteMesagge("No se pudo conectar con el servidor de pagos. Verifica tu conexión o VPN.");
      setLoading(false);
    }
  };

  const completeTable = () => {
    const matriculaStr = String(alumno.codigo);
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    let tablaCopia = JSON.parse(JSON.stringify(tablaConceptos));

    const yaVienenAgrupados = tablaCopia.every(
      (item) => item.referencias && item.referencias.Banorte && item.referencias.Banorte.length > 20
    );

    if (!yaVienenAgrupados) {
      const todasLasClaves = tablaCopia.map((item) => item.clave);
      const montoTotalBolsa = tablaCopia.reduce((sum, item) => sum + Number(item.precio), 0);

      const datosRefUnicaM97 = generarLineaCaptura(
        plantelOficialAlumno,
        todasLasClaves,
        matriculaStr,
        montoTotalBolsa
      );

      setFechaVencimiento(datosRefUnicaM97.banorte.fechaVencimientoStr);

      for (let i = 0; i < tablaCopia.length; i++) {
        tablaCopia[i].id = i + 1;
        tablaCopia[i].referencias = {
          Banorte: datosRefUnicaM97.banorte.lineaDeCaptura,
          BBVA: datosRefUnicaM97.bancomer.lineaDeCaptura
        };
      }
    } else {
      for (let i = 0; i < tablaCopia.length; i++) {
        tablaCopia[i].id = i + 1;
      }
    }
    const fechaHeredada =
      datospago?.detallesCompletos?.banorte?.fechaVencimientoStr ||
      datospago?.fechaVencimiento;

    if (!fechaVencimiento && fechaHeredada) {
      setFechaVencimiento(fechaHeredada);
    }
    setConceptosProcesados(tablaCopia);
  };

  useEffect(() => {
    completeTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tablaConceptos]);

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : loading ? (
    <div className="loading_spinner">
      <div className="lds-ring">
        <div></div><div></div><div></div><div></div>
      </div>
    </div>
  ) : banorteMessage ? (
    <div className="FormaPago container">
      <h1 className="Banorte_message">{banorteMessage}</h1>
    </div>
  ) : (
    <div className="FormaPago container">
      <button className="FormaPago-btn-regresar" onClick={() => history.goBack()}>
        &#8592; Regresar
      </button>

      <h2>Elige tu Forma de pago</h2>
      <div className="FormaPago-flex">
        
        <div className="FormaPago-linea" onClick={() => {
            const importeBruto = conceptosProcesados.length > 0
              ? conceptosProcesados.reduce((sum, item) => sum + Number(item.precio), 0)
              : datospago.importe;

            const importeParaBanco = Number(importeBruto).toFixed(2);
            const referenciaCompleta = conceptosProcesados.length > 0 && conceptosProcesados[0].referencias?.Banorte
              ? conceptosProcesados[0].referencias.Banorte
              : datospago.referencia;

            const referenciaOficial26 = referenciaCompleta ? referenciaCompleta.substring(0, 26) : "";
            const sufijoTiempo = Date.now().toString().slice(-4);
            const referenciaParaBanco = referenciaOficial26 ? referenciaOficial26 + sufijoTiempo : "";

            pagoBanorte(importeParaBanco, referenciaParaBanco);
          }}
        >
          <div className="contenedor-imagen">
            <input className="FormaPago-linea-img" type="image" src={PLinea} alt="Pago en línea" />
          </div>
          <p>Tarjetas de credito y debito <br /> (VISA y MasterCard) de cualquier banco.</p>
        </div>

        <form action="https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado" method="post" style={{ display: "none" }}>
          <input type="hidden" name="importe" value={datospago.importe} />
          <input type="hidden" name="referencia" value={datospago.referencia} />
          <input type="hidden" name="urlretorno" value="http://www.cecytejalisco.edu.mx/" />
          <input type="hidden" name="idexpress" value="2075" />
          <input type="hidden" name="financiamiento" value="0" />
          <input type="hidden" name="plazos" value="" />
          <input type="hidden" name="mediospago" value="000000" />
          <input type="hidden" name="signature" value={datospago.key} />
        </form>

        <div className="FormaPago-referencia">
          <div className="contenedor-imagen">
            <input
              className="FormaPago-ventanilla-img"
              type="image"
              src={ventanilla}
              onClick={handleOnClickVentanilla}
              alt="Pago en ventanilla"
            />
          </div>
          <p>Pago en ventanilla de banco, <br /> practicajas y aplicación móvil</p>
          
          {/* AQUÍ RESTAURAMOS EL BOTÓN VERDE */}
          {pdf && conceptosProcesados.length > 0 ? (
            cargandoPdf ? (
              <p style={{ color: "#005b9f", fontWeight: "bold", marginTop: "10px" }}>Cargando documento...</p>
            ) : (
              <button
                onClick={() => descargarPdf(conceptosProcesados, folioRegistro, fechaVencimiento)}
                style={{
                  backgroundColor: '#28a745',
                  color: '#ffffff',
                  padding: '12px 24px',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  marginTop: '10px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
              >
                Descargar orden de pago
              </button>
            )
          ) : null}

        </div>
      </div>
    </div>
  );
};

export default FormaPago;